const EventScheduleEvent = {
  fetchOne: 'event-schedule/fetch-one',
  onEdit: 'event-schedule/on-edit',
  onClear: 'event-schedule/on-clear'
}

export default EventScheduleEvent
